import React from "react";
import { CheckCircle, Database, Download, Server } from "lucide-react";
import { AdminPageHeader, Badge, Button, ListRow, Page, Panel, StatCard, StatGrid } from "../AdminKit";

const tables = [
  { name: "products", rows: "1,284 rows", status: "정상" },
  { name: "orders", rows: "8,492 rows", status: "정상" },
  { name: "members", rows: "12,884 rows", status: "정상" },
  { name: "coupons", rows: "76 rows", status: "정상" },
];

export default function AdminDatabase() {
  return (
    <Page>
      <AdminPageHeader title="데이터베이스" description="쇼핑몰 주요 데이터 테이블과 백업 상태를 점검합니다." />
      <StatGrid>
        <StatCard><Database size={24} /><span>주요 테이블</span><strong>18개</strong></StatCard>
        <StatCard><Server size={24} /><span>DB 상태</span><strong>Online</strong></StatCard>
        <StatCard><CheckCircle size={24} /><span>최근 백업</span><strong>03:00</strong></StatCard>
      </StatGrid>
      <Panel>
        <header><h2>테이블 상태</h2><Button><Download size={16} /> 백업 다운로드</Button></header>
        {tables.map((table) => (
          <ListRow key={table.name} $columns="1fr 160px 100px 120px">
            <div><strong>{table.name}</strong><span>운영 데이터</span></div>
            <span>{table.rows}</span>
            <Badge $bg="#ecfdf5" $fg="#059669">{table.status}</Badge>
            <Button>점검</Button>
          </ListRow>
        ))}
      </Panel>
    </Page>
  );
}
